import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo13/terrenolimpio.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad3Actividad8.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[10];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[9].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[9].path}`,
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[11].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[11].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-md-4 col-12">
          <ul className="mb-4">
            <li>
              Ahora construiremos algo con los objetos que identificaste en la
              actividad anterior.
            </li>
            <li>
              ¿Qué podrías construir para el parque con los objetos desechados
              de la actividad anterior? Escríbelos aquí. Por ejemplo: un túnel
              hecho con llantas.
            </li>
          </ul>
          <textarea className="form-control" rows={8} />
        </div>
        <div className="col-md-8 col-12">
          <img src={Imagen1} className="img-fluid" alt="Peruanos" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Ahora construiremos algo con los objetos
            que identificaste en la actividad anterior. Pida que observen la
            imagen propuesta y pregunte:
            <ul>
              <li>
                <i>
                  “¿De qué forma han reutilizado las llantas en la imagen?
                  (Posible respuesta: Las han reutilizado para hacer un túnel
                  que sirva para que los niños y niñas jueguen. Al pintar las
                  llantas de colores, las han hecho más atractivas).
                </i>
              </li>
              <li>
                <i>
                  ¿De qué forma han reutilizado las latas? (Posible respuesta:
                  Con las latas han hecho unas macetas en las que han plantado
                  flores)”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora revise los objetos apuntados. Lea la segunda indicación:
            Trabaja con tu mismo compañero o compañera. Elaboren un dibujo en el
            que utilicen la mayor cantidad de objetos de la actividad anterior
            para crear un parque de juegos para niños. Explique que, así como
            las llantas y las macetas fueron reutilizadas, ahora tienen que
            transformar los objetos que aparecen en la lista apuntada en juegos
            para niños y niñas. Primero deben ponerse de acuerdo en cómo
            reutilizarán los objetos y después dibujarán. Déles tiempo para que
            elaboren el dibujo. Pregunte por cada uno de los objetos en la
            lista. Por ejemplo, ¿en qué transformaron las llantas? Siga así con
            todos los objetos.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
